import React from 'react';
import { stateToColor } from '../../../../constants/styling/styles';
import { showState } from '../../../../selectors/events/timetable';
import Checkmark from '@material-ui/icons/Check';
import Clear from '@material-ui/icons/Clear';
import { toDisplayString, isBefore, isUnlimited } from '../../../../lib/date.utils';
import { requireUseUntil } from '../../../../selectors/admin/models/lineup';

function _renderState(state = '', label) {
    return showState(state) ? (
        <React.Fragment>
            <span className="ckp-timetable-entry-state u-truncate">
                <span className="u-bold ckp-timetable-entry-state-label">{label}</span> {state.replace(/_/g, ' ')}
            </span>
            <span className={`ckp-timetable-entry-bar is-${stateToColor(state)}`} />
        </React.Fragment>
    ) : null;
}

const States = ({ clearing, isLiveView }) => (
    <span className="ckp-timetable-entry-states">
        {isLiveView ? (
            <React.Fragment>
                {_renderState(clearing.live, 'Live')}
                {_renderState(clearing.nonLinear, 'Non Linear')}
            </React.Fragment>
        ) : (
            <React.Fragment>
                {_renderState(clearing.nonLinear, 'Non Linear')}
                <span className="ckp-timetable-entry-state u-truncate">
                    {clearing.useUntil && requireUseUntil(clearing.nonLinear) ? (
                        <React.Fragment>
                            <span className="u-bold ckp-timetable-entry-state-label">Use until</span>
                            {isUnlimited(clearing.useUntil) ? 'Unlimited' : toDisplayString(clearing.useUntil)}
                            {isUnlimited(clearing.useUntil) || isBefore(Date.now(), clearing.useUntil) ? (
                                <Checkmark className="ckp-timetable-entry-check-icon" />
                            ) : (
                                <Clear className="ckp-timetable-entry-clear-icon" />
                            )}
                        </React.Fragment>
                    ) : null}
                </span>
            </React.Fragment>
        )}
    </span>
);

export default States;



// WEBPACK FOOTER //
// ./src/components/application/timetable/entries/States.js